import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SOLICITUD_VIA_PAGO_RESPONSE, VOUCHER_PAGE_PROPERTIES } from '@constants/cambio-via-pago-properties.constants';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from '@constants/url.constant';
import { ISolicitudResponse } from '@interfaces/solicitud-cambio-via-pago.response.interface';

import { VoucherProperties } from '@interfaces/voucher-properties.interface';
import { StorageService } from '@services/storage/storage.service';

@Component({
    selector: 'app-cambio-via-pago-comprobante',
    templateUrl: './cambio-via-pago-comprobante.component.html',
    styleUrls: ['./cambio-via-pago-comprobante.component.scss'],
    standalone: false
})
export class CambioViaPagoComprobanteComponent implements OnInit {

  public voucherProperties: VoucherProperties = VOUCHER_PAGE_PROPERTIES;
  public solicitudResponse: ISolicitudResponse;
  public loading: boolean = false;

  constructor( private readonly router: Router,private readonly storageService: StorageService,) { }

  async ngOnInit() {
    this.loading = true;
    this.solicitudResponse = await this.storageService.get(SOLICITUD_VIA_PAGO_RESPONSE);

    if(this.solicitudResponse) this.loading = false;
    
  }

  public goToHome(): void {
    this.router.navigate([ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME])
  }


}
